import React, { CSSProperties, FC, useCallback, useEffect, useMemo, useState } from 'react'
import './TestimoniesModulesLanding.scss'
import LandingService from 'app_services/admin/landings/landingService'
import { ILanding, IReferences, TypeSlugLanding } from 'app_types/admin/landings/landingTypes'
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper'
import useWindowWidth from 'app_hooks/useWindowWidth'
import { Carousel } from 'react-bootstrap'
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'

const MOVIL_BREAKPOINT = 800

const navigationStyles: CSSProperties = {
  marginBottom: '100px'
}

interface ITestimoniesModulesLandingProps {
  slug: TypeSlugLanding
}

const TestimoniesModulesLanding: FC<ITestimoniesModulesLandingProps> = ({
  slug
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [landing, setLanding] = useState<ILanding>()
  const { windowWidth } = useWindowWidth()
  const isMovil = windowWidth && windowWidth <= MOVIL_BREAKPOINT
  const references = useMemo(() => landing?.landing?.references ? landing?.landing?.references : [], [landing])

  const fetchData = useCallback(async () => {
    const landingService = new LandingService()
    let httpParams: any = {
      slug,
    }
    setIsLoading(true)
    const landingResponse = await landingService.fetchLandingData(httpParams)
    if (landingResponse) {
      setLanding(landingResponse)
    }
    setIsLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  function shuffleArray(array: IReferences[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  if (!references?.length) return null

  return (
    <div className='testimonies-modules-landing--container'>
        <h2 className='testimonies-modules-landing--container-title'>Testimonios</h2>
        <LoadingWrapper loading={isLoading}>
          <>
            {!isMovil && (
              <div className='testimonies-modules-landing--target-container'>
                {shuffleArray(references)?.filter((reference) => reference?.active)?.slice(0, 3)?.map((reference) => (
                  <div key={reference?.unique} className='testimonies-modules-landing--text-container'>
                    <img className='testimonies-modules-landing--image' src={reference?.url} alt={`Imagen de la referencia de ${reference?.client}`} />
                    <p className='testimonies-modules-landing--text'>{reference?.description}</p>
                  </div>
                ))}
              </div>
            )}
            {isMovil && (
              <Carousel
                indicators={false}
                nextIcon={(
                  <div style={navigationStyles}>
                    <MdKeyboardArrowRight size='60px' color='#E5F7FF' />
                  </div>
                )}
                prevIcon={(
                  <div style={navigationStyles}>
                    <MdKeyboardArrowLeft size='60px' color='#E5F7FF' />
                  </div>
                )}
              >
                {shuffleArray(references)?.filter((reference) => reference?.active)?.map((reference) => (
                  <Carousel.Item>
                    <div key={reference?.unique} className='testimonies-modules-landing--text-container'>
                      <img className='testimonies-modules-landing--image' src={reference?.url} alt={`Imagen de la referencia de ${reference?.client}`} />
                      <p className='testimonies-modules-landing--text'>{reference?.description}</p>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            )}
          </>
        </LoadingWrapper>
    </div>
  )
}

export default TestimoniesModulesLanding
